import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class SchoolsSearchBarMenuItem extends Component {
    render() {
        const {term, taxonomy, current} = this.props;

        return (
            <div className="col col-4" key={term.term_id}>
                <a data-id={term.term_id} data-taxonomy={taxonomy} onClick={this.props.handleClick} className={classnames('', {
                    'active': (parseInt(current, 10) === parseInt(term.term_id, 10)),
                })}>
                    <span>{term.name}</span>
                </a>
            </div>
        );
    }
}

SchoolsSearchBarMenuItem.propTypes = {
    term: PropTypes.object.isRequired,
    taxonomy: PropTypes.string.isRequired,
    current: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
};

export default SchoolsSearchBarMenuItem;


// WEBPACK FOOTER //
// ./src/features/Schools/components/SearchBar/SchoolsSearchBarMenuItem.js